var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "d-block", attrs: { "fill-height": "", fluid: "" } },
    [
      _c(
        "div",
        { staticClass: "pa-5" },
        [
          _c(
            "v-btn",
            { attrs: { color: "primary" }, on: { click: _vm.openDialog } },
            [
              _c("v-icon", [_vm._v("mdi-plus")]),
              _vm._v(" " + _vm._s(_vm.$t("label.newUser")) + " "),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { width: "50%", "max-width": "600px", persistent: "" },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline grey lighten-2 pb-3" },
                    [_vm._v(" " + _vm._s(_vm.$t("label.newUser")) + " ")]
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass: "ma-3",
                      attrs: { type: "error", dismissible: "" },
                      model: {
                        value: _vm.errorAlert,
                        callback: function ($$v) {
                          _vm.errorAlert = $$v
                        },
                        expression: "errorAlert",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "pt-4" },
                    [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { autocomplete: "off" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("label.username"),
                                      outlined: "",
                                      dense: "",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.userData.username,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.userData, "username", $$v)
                                      },
                                      expression: "userData.username",
                                    },
                                  }),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("label.password"),
                                      type: "password",
                                      outlined: "",
                                      dense: "",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.userData.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.userData, "password", $$v)
                                      },
                                      expression: "userData.password",
                                    },
                                  }),
                                  _c("v-select", {
                                    attrs: {
                                      label: _vm.$t("label.groups"),
                                      items: _vm.groups,
                                      "item-text": "groupDes",
                                      "item-value": "id",
                                      "return-object": "",
                                      multiple: "",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.userData.groups,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.userData, "groups", $$v)
                                      },
                                      expression: "userData.groups",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("label.email"),
                                      type: "email",
                                      outlined: "",
                                      dense: "",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.userData.email,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.userData, "email", $$v)
                                      },
                                      expression: "userData.email",
                                    },
                                  }),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("label.repeatPassword"),
                                      type: "password",
                                      outlined: "",
                                      dense: "",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.userData.repeatPassword,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.userData,
                                          "repeatPassword",
                                          $$v
                                        )
                                      },
                                      expression: "userData.repeatPassword",
                                    },
                                  }),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.companies,
                                      "item-text": "name",
                                      "item-key": "id",
                                      "return-object": "",
                                      label: _vm.$t("label.organization"),
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.selectedCompany,
                                      callback: function ($$v) {
                                        _vm.selectedCompany = $$v
                                      },
                                      expression: "selectedCompany",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "subtitle-2 mb-2 text--secondary",
                                },
                                [_vm._v("Roles Assignments")]
                              ),
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "4" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          value: "shipper",
                                          label: "Shipper",
                                          disabled:
                                            !_vm.selectedCompany?.isCustomer,
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.selectedRoles,
                                          callback: function ($$v) {
                                            _vm.selectedRoles = $$v
                                          },
                                          expression: "selectedRoles",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "4" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          value: "consignee",
                                          label: "Consignee",
                                          disabled:
                                            !_vm.selectedCompany?.isCustomer,
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.selectedRoles,
                                          callback: function ($$v) {
                                            _vm.selectedRoles = $$v
                                          },
                                          expression: "selectedRoles",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "4" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          value: "clientFrom",
                                          label: "Client From",
                                          disabled:
                                            !_vm.selectedCompany?.isCustomer,
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.selectedRoles,
                                          callback: function ($$v) {
                                            _vm.selectedRoles = $$v
                                          },
                                          expression: "selectedRoles",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "4" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          value: "clientTo",
                                          label: "Client To",
                                          disabled:
                                            !_vm.selectedCompany?.isCustomer,
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.selectedRoles,
                                          callback: function ($$v) {
                                            _vm.selectedRoles = $$v
                                          },
                                          expression: "selectedRoles",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "4" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          value: "foreignAgent",
                                          label: "Foreign Agent",
                                          disabled:
                                            !_vm.selectedCompany?.isSupplier,
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.selectedRoles,
                                          callback: function ($$v) {
                                            _vm.selectedRoles = $$v
                                          },
                                          expression: "selectedRoles",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "pa-3" },
                    [
                      _c("v-spacer"),
                      _c("v-btn", { on: { click: _vm.closeDialog } }, [
                        _vm._v(_vm._s(_vm.$t("label.cancel"))),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "px-4",
                          attrs: { color: "primary" },
                          on: { click: _vm.saveUser },
                        },
                        [_vm._v(_vm._s(_vm.$t("label.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.loading
        ? _c("v-progress-linear", {
            staticClass: "mb-1",
            attrs: { indeterminate: "", color: "primary" },
          })
        : _vm._e(),
      _c(
        "v-expansion-panels",
        {
          staticClass: "align-self-start",
          attrs: { width: "100%" },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        _vm._l(_vm.users, function (user, i) {
          return _c(
            "v-expansion-panel",
            { key: i },
            [
              _c(
                "v-expansion-panel-header",
                {
                  staticClass: "px-3 py-0",
                  attrs: { "disable-icon-rotate": "" },
                  scopedSlots: _vm._u(
                    [
                      _vm.panel == i
                        ? {
                            key: "actions",
                            fn: function () {
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "red", fab: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.confirmDelete.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { size: "25", color: "white" } },
                                      [_vm._v("mdi-delete")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-dialog",
                                  {
                                    attrs: { "max-width": "500px" },
                                    model: {
                                      value: _vm.deleteDialog,
                                      callback: function ($$v) {
                                        _vm.deleteDialog = $$v
                                      },
                                      expression: "deleteDialog",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-card",
                                      [
                                        _c(
                                          "v-card-title",
                                          { staticClass: "headline" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("label.confirmDelete")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-card-text", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.confirmDeletion")
                                            )
                                          ),
                                        ]),
                                        _c(
                                          "v-card-actions",
                                          [
                                            _c("v-spacer"),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  text: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.deleteDialog = false
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("label.cancel"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "white--text",
                                                attrs: { color: "red" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteUser(user)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("label.delete"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      fab: "",
                                      small: "",
                                      color: "success",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.updateUser(user)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { size: "25", color: "white" } },
                                      [_vm._v("mdi-content-save")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0" },
                    [
                      _c("v-col", { staticClass: "d-flex align-center pa-0" }, [
                        _c("span", [_vm._v(_vm._s(user.username))]),
                      ]),
                      _c("v-col", { staticClass: "d-flex align-center pa-0" }, [
                        _c("span", [_vm._v(_vm._s(user.email))]),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pa-0" },
                        _vm._l(user.groups, function (element, k) {
                          return _c(
                            "v-chip",
                            {
                              key: k,
                              staticClass: "ma-2 pa-2 text-overline",
                              attrs: { color: "primary", small: "" },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "pr-1", attrs: { small: "" } },
                                [_vm._v(_vm._s(_vm.getIcon(element.groupDes)))]
                              ),
                              _vm._v(" " + _vm._s(element.groupDes) + " "),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0" },
                    [
                      _c("v-col", { staticClass: "pa-0 pl-3" }, [
                        _c(
                          "span",
                          { staticClass: "text-overline primary--text" },
                          [_vm._v(_vm._s(_vm.$t("label.settings")))]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "mx-2 mt-0 mb-4" }),
                  _c(
                    "v-row",
                    { staticClass: "mx-0" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-2",
                          attrs: { cols: "12", sm: "6", md: "4" },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("label.email"),
                              autocomplete: "off",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: user.email,
                              callback: function ($$v) {
                                _vm.$set(user, "email", $$v)
                              },
                              expression: "user.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-2",
                          attrs: { cols: "12", sm: "6", md: "4" },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("label.password"),
                              autocomplete: "new-password",
                              type: "password",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: user.password,
                              callback: function ($$v) {
                                _vm.$set(user, "password", $$v)
                              },
                              expression: "user.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-2",
                          attrs: { cols: "12", sm: "6", md: "4" },
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.languageItems,
                              label: _vm.$t("label.language"),
                              "item-text": "text",
                              "return-object": "",
                              "prepend-inner-icon": "mdi-translate",
                              outlined: "",
                              dense: "",
                            },
                            on: { change: _vm.changeLanguage },
                            model: {
                              value: user.language,
                              callback: function ($$v) {
                                _vm.$set(user, "language", $$v)
                              },
                              expression: "user.language",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mx-0" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-2",
                          attrs: { cols: "12", sm: "6", md: "4" },
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.groups,
                              label: _vm.$t("label.groups"),
                              "item-text": "groupDes",
                              "item-value": "id",
                              "return-object": "",
                              "prepend-inner-icon": "mdi-account-group",
                              multiple: "",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: user.groups,
                              callback: function ($$v) {
                                _vm.$set(user, "groups", $$v)
                              },
                              expression: "user.groups",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-2",
                          attrs: { cols: "12", sm: "6", md: "4" },
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.companies,
                              "item-text": "name",
                              "item-key": "id",
                              "return-object": "",
                              label: _vm.$t("label.organization"),
                              "prepend-inner-icon": "mdi-domain",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: user.selectedCompany,
                              callback: function ($$v) {
                                _vm.$set(user, "selectedCompany", $$v)
                              },
                              expression: "user.selectedCompany",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mx-2 mt-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "subtitle-2 mb-1 text--secondary" },
                        [_vm._v("Roles Assignments")]
                      ),
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "2" } },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  value: "shipper",
                                  label: "Shipper",
                                  disabled: !user.selectedCompany?.isCustomer,
                                  dense: "",
                                },
                                model: {
                                  value: user.selectedRoles,
                                  callback: function ($$v) {
                                    _vm.$set(user, "selectedRoles", $$v)
                                  },
                                  expression: "user.selectedRoles",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "2" } },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  value: "consignee",
                                  label: "Consignee",
                                  disabled: !user.selectedCompany?.isCustomer,
                                  dense: "",
                                },
                                model: {
                                  value: user.selectedRoles,
                                  callback: function ($$v) {
                                    _vm.$set(user, "selectedRoles", $$v)
                                  },
                                  expression: "user.selectedRoles",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "2" } },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  value: "clientFrom",
                                  label: "Client From",
                                  disabled: !user.selectedCompany?.isCustomer,
                                  dense: "",
                                },
                                model: {
                                  value: user.selectedRoles,
                                  callback: function ($$v) {
                                    _vm.$set(user, "selectedRoles", $$v)
                                  },
                                  expression: "user.selectedRoles",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "2" } },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  value: "clientTo",
                                  label: "Client To",
                                  disabled: !user.selectedCompany?.isCustomer,
                                  dense: "",
                                },
                                model: {
                                  value: user.selectedRoles,
                                  callback: function ($$v) {
                                    _vm.$set(user, "selectedRoles", $$v)
                                  },
                                  expression: "user.selectedRoles",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "2" } },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  value: "foreignAgent",
                                  label: "Foreign Agent",
                                  disabled: !user.selectedCompany?.isSupplier,
                                  dense: "",
                                },
                                model: {
                                  value: user.selectedRoles,
                                  callback: function ($$v) {
                                    _vm.$set(user, "selectedRoles", $$v)
                                  },
                                  expression: "user.selectedRoles",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }